import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import Auth from '@aws-amplify/auth';
import API, {GRAPHQL_AUTH_MODE} from "@aws-amplify/api";
import {getDynamoUserRecord} from "../graphql/queries";

const fetchCurrentAuthenticatedUser = createAsyncThunk(
  'cognito/fetchCurrentAuthenticatedUser',
  async () => {
    return JSON.parse(JSON.stringify(await Auth.currentAuthenticatedUser()));
  }
);

const fetchCurrentCredentials = createAsyncThunk(
  'cognito/fetchCurrentCredentials',
  async () => {
    return await Auth.currentCredentials();
  }
);

const fetchCurrentSession = createAsyncThunk(
  'cognito/fetchCurrentSession',
  async () => {
    return await Auth.currentSession();
  }
);

const fetchCurrentUserCredentials = createAsyncThunk(
  'cognito/fetchCurrentUserCredentials',
  async () => {
    return await Auth.currentUserCredentials();
  }
);

const fetchCurrentUserInfo = createAsyncThunk(
  'cognito/fetchCurrentUserInfo',
  async () => {
    return await Auth.currentUserInfo();
  }
);

const fetchCurrentUserPoolUser = createAsyncThunk(
  'cognito/fetchCurrentUserPoolUser',
  async () => {
    return await Auth.currentUserPoolUser();
  }
);

const getUserDynamoRecord = createAsyncThunk(
  'cognito/getUserDynamoRecord',
  async () => {
    return await API.graphql({query: getDynamoUserRecord, variables: {userName: await (Auth.currentUserInfo()).username}, authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS});
  }
);

// const fetchAll = createAsyncThunk(
//   'cognito/fetchAll',
//   async () => {
//     let currentAuthenticatedUser;
//     let currentCredentials;
//     let currentSession;
//     let currentUserCredentials;
//     let currentUserInfo;
//     let currentUserPoolUser;
//
//     await Promise.all([
//       Auth.currentAuthenticatedUser().then((response) => {currentAuthenticatedUser = response}),
//       Auth.currentCredentials().then((response) => {currentCredentials = response}),
//       Auth.currentSession().then((response) => {currentSession = response}),
//       Auth.currentUserCredentials().then((response) => {currentUserCredentials = response}),
//       Auth.currentUserInfo().then((response) => {currentUserInfo = response}),
//       Auth.currentUserPoolUser().then((response) => {currentUserPoolUser = response}),
//     ]);
//
//     return {
//       currentAuthenticatedUser,
//       currentCredentials,
//       currentSession,
//       currentUserCredentials,
//       currentUserInfo,
//       currentUserPoolUser,
//     };
//   }
// );

// Then, handle actions in your reducers:
const cognitoSlice = createSlice({
  name: 'cognito',
  // When null, it means it is not loaded yet. When false, it means that there is no login or no data fetchable. When value, then value
  initialState: {
    currentAuthenticatedUser: null,
    currentCredentials: null,
    currentSession: null,
    currentUserCredentials: null,
    currentUserInfo: null,
    currentUserPoolUser: null,
    userDynamoRecord: null,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchCurrentAuthenticatedUser.fulfilled]: (state, action) => {
      state.currentAuthenticatedUser = action.payload || false;
    },
    [fetchCurrentAuthenticatedUser.rejected]: (state, action) => {
      state.currentAuthenticatedUser = false;
    },
    [fetchCurrentCredentials.fulfilled]: (state, action) => {
      state.currentCredentials = action.payload || false;
    },
    [fetchCurrentCredentials.rejected]: (state, action) => {
      state.currentCredentials = false;
    },
    [fetchCurrentSession.fulfilled]: (state, action) => {
      state.currentSession = action.payload || false;
    },
    [fetchCurrentSession.rejected]: (state, action) => {
      state.currentSession = false;
    },
    [fetchCurrentUserCredentials.fulfilled]: (state, action) => {
      state.currentUserCredentials = action.payload || false;
    },
    [fetchCurrentUserCredentials.rejected]: (state, action) => {
      state.currentUserCredentials = false;
    },
    [fetchCurrentUserInfo.fulfilled]: (state, action) => {
      state.currentUserInfo = action.payload || false;
    },
    [fetchCurrentUserInfo.rejected]: (state, action) => {
      state.currentUserInfo = false;
    },
    [fetchCurrentUserPoolUser.fulfilled]: (state, action) => {
      state.currentUserPoolUser = action.payload || false;
    },
    [fetchCurrentUserPoolUser.rejected]: (state, action) => {
      state.currentUserPoolUser = false;
    },
    [getUserDynamoRecord.fulfilled]: (state, action) => {
      state.userDynamoRecord = action.payload?.data?.getDynamoUserRecord || false;
    },
    [getUserDynamoRecord.rejected]: (state, action) => {
      console.log('Dynamo record fetch failed');
      state.userDynamoRecord = false;
    },
    // [fetchAll.fulfilled]: (state, action) => {
    //   state = action.payload;
    //   //Object.keys(state).forEach(key => state[key] = action.payload[key]);
    // }
  }
});

export {fetchCurrentAuthenticatedUser, fetchCurrentCredentials, fetchCurrentUserPoolUser, fetchCurrentUserInfo, fetchCurrentUserCredentials, fetchCurrentSession, getUserDynamoRecord, /*fetchAll*/};

export default cognitoSlice.reducer;
